import React from "react";
import { Form } from "react-bootstrap";
const labelArray = [
  {
    label: "Live",
    value: true,
  },
  {
    label: "Test",
    value: false,
  },
];

function CustomToggleButton(props) {
  const {
    isChecked = false,
    onChangeFunction = () => {},
    displayValues = labelArray,
    idName = "0",
  } = props;
  return (
    <div
      className="custom-toggle-button-container"
      style={{ position: "relative" }}
    >
      {isChecked && (
        <div
          style={{
            position: "absolute",
            fontSize: "12px",
            zIndex: "200",
            marginTop: "3px",
            marginLeft: "5px",
            color: "white",
            marginLeft: "5px",
          }}
        >
          {labelArray[0].label}
        </div>
      )}
      {!isChecked && (
        <div
          style={{
            position: "absolute",
            marginLeft: "30px",
            fontSize: "12px",
            zIndex: "200",
            marginTop: "3px",
            color: "white",
          }}
        >
          {labelArray[1].label}
        </div>
      )}
      <Form.Check
        custom
        id={"showTerminated" + idName}
        name="showTerminated"
        type="switch"
        //   label="&nbsp;&nbsp;Show Terminated"
        autoFocus="off"
        onChange={() => {
          onChangeFunction(isChecked ? false : true);
        }}
        checked={isChecked}
        className="medium"
      />
    </div>
  );
}

export default CustomToggleButton;
